import dynamic from 'next/dynamic';
import { RecordWinsSkeleton } from './ui/record-wins-skeleton';

const DynamicRecordWins = dynamic(
  () => import('./ui/record-wins').then((m) => m.RecordWins),
  {
    ssr: false,
    loading: () => <RecordWinsSkeleton />,
  }
);

export { DynamicRecordWins };
